import { render, staticRenderFns } from "./loader-pie-total.vue?vue&type=template&id=3799f094&"
import script from "./loader-pie-total.vue?vue&type=script&lang=js&"
export * from "./loader-pie-total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports